import { default as agb_45bestaetigungWGQG5fuefIMeta } from "/app/src/pages/agb-bestaetigung.vue?macro=true";
import { default as angebotef28pZZ8F2RMeta } from "/app/src/pages/angebote.vue?macro=true";
import { default as profilx0MRfJw6KyMeta } from "/app/src/pages/app/account/profil.vue?macro=true";
import { default as faqH2Wmsf6s2vMeta } from "/app/src/pages/app/admin/faq.vue?macro=true";
import { default as institutionenb1pbWN0C4zMeta } from "/app/src/pages/app/admin/institutionen.vue?macro=true";
import { default as mitgliederC7gzJyGBHhMeta } from "/app/src/pages/app/admin/mitglieder.vue?macro=true";
import { default as news7cRuAHR06iMeta } from "/app/src/pages/app/admin/news.vue?macro=true";
import { default as veranstaltungen0S7ZDt9jDcMeta } from "/app/src/pages/app/admin/veranstaltungen.vue?macro=true";
import { default as adminQhwbRj5KktMeta } from "/app/src/pages/app/admin.vue?macro=true";
import { default as chatSKyrYO3xLDMeta } from "/app/src/pages/app/chat.vue?macro=true";
import { default as einstellungenmSZoZNUdDNMeta } from "/app/src/pages/app/einstellungen.vue?macro=true";
import { default as indexfKUSU0AQxdMeta } from "/app/src/pages/app/index.vue?macro=true";
import { default as _91id_93q0BmeojNZeMeta } from "/app/src/pages/app/institution/[id].vue?macro=true";
import { default as institutionen5wtRQI6kw9Meta } from "/app/src/pages/app/institutionen.vue?macro=true";
import { default as kontakteSgoWUtYWI0Meta } from "/app/src/pages/app/kontakte.vue?macro=true";
import { default as matchingfOeFltIJz8Meta } from "/app/src/pages/app/matching.vue?macro=true";
import { default as mitteilungenVX2ni1J1gFMeta } from "/app/src/pages/app/mitteilungen.vue?macro=true";
import { default as _91userId_93OgcacasGSJMeta } from "/app/src/pages/app/profil/[userId].vue?macro=true";
import { default as loginOk5zcM8cXjMeta } from "/app/src/pages/auth/login.vue?macro=true";
import { default as _91token_9359Vx11OGDbMeta } from "/app/src/pages/auth/passwort-setzen/[token].vue?macro=true";
import { default as registrierung5w0OIWNiY4Meta } from "/app/src/pages/auth/registrierung.vue?macro=true";
import { default as verifizierungsmailEIHeijMlzeMeta } from "/app/src/pages/auth/verifizierungsmail.vue?macro=true";
import { default as datenschutzE0haYOhlidMeta } from "/app/src/pages/datenschutz.vue?macro=true";
import { default as faq76HkPfXsDsMeta } from "/app/src/pages/faq.vue?macro=true";
import { default as impressumNJVjPy3KjkMeta } from "/app/src/pages/impressum.vue?macro=true";
import { default as indexdPwi6hPdMfMeta } from "/app/src/pages/index.vue?macro=true";
import { default as kontaktBffrmfo0rhMeta } from "/app/src/pages/kontakt.vue?macro=true";
import { default as nutzungsbedingungen5rPR60goIIMeta } from "/app/src/pages/nutzungsbedingungen.vue?macro=true";
import { default as suche1ddJyy3oLYMeta } from "/app/src/pages/suche.vue?macro=true";
import { default as ueber_45unssnp4ZFYTkuMeta } from "/app/src/pages/ueber-uns.vue?macro=true";
import { default as veranstaltungenIBcaL1MnfAMeta } from "/app/src/pages/veranstaltungen.vue?macro=true";
export default [
  {
    name: "agb-bestaetigung",
    path: "/agb-bestaetigung",
    component: () => import("/app/src/pages/agb-bestaetigung.vue")
  },
  {
    name: "angebote",
    path: "/angebote",
    component: () => import("/app/src/pages/angebote.vue")
  },
  {
    name: "app-account-profil",
    path: "/app/account/profil",
    component: () => import("/app/src/pages/app/account/profil.vue")
  },
  {
    name: "app-admin",
    path: "/app/admin",
    component: () => import("/app/src/pages/app/admin.vue"),
    children: [
  {
    name: "app-admin-faq",
    path: "faq",
    component: () => import("/app/src/pages/app/admin/faq.vue")
  },
  {
    name: "app-admin-institutionen",
    path: "institutionen",
    component: () => import("/app/src/pages/app/admin/institutionen.vue")
  },
  {
    name: "app-admin-mitglieder",
    path: "mitglieder",
    component: () => import("/app/src/pages/app/admin/mitglieder.vue")
  },
  {
    name: "app-admin-news",
    path: "news",
    component: () => import("/app/src/pages/app/admin/news.vue")
  },
  {
    name: "app-admin-veranstaltungen",
    path: "veranstaltungen",
    component: () => import("/app/src/pages/app/admin/veranstaltungen.vue")
  }
]
  },
  {
    name: "app-chat",
    path: "/app/chat",
    component: () => import("/app/src/pages/app/chat.vue")
  },
  {
    name: "app-einstellungen",
    path: "/app/einstellungen",
    component: () => import("/app/src/pages/app/einstellungen.vue")
  },
  {
    name: "app",
    path: "/app",
    component: () => import("/app/src/pages/app/index.vue")
  },
  {
    name: "app-institution-id",
    path: "/app/institution/:id()",
    component: () => import("/app/src/pages/app/institution/[id].vue")
  },
  {
    name: "app-institutionen",
    path: "/app/institutionen",
    component: () => import("/app/src/pages/app/institutionen.vue")
  },
  {
    name: "app-kontakte",
    path: "/app/kontakte",
    component: () => import("/app/src/pages/app/kontakte.vue")
  },
  {
    name: "app-matching",
    path: "/app/matching",
    component: () => import("/app/src/pages/app/matching.vue")
  },
  {
    name: "app-mitteilungen",
    path: "/app/mitteilungen",
    component: () => import("/app/src/pages/app/mitteilungen.vue")
  },
  {
    name: "app-profil-userId",
    path: "/app/profil/:userId()",
    component: () => import("/app/src/pages/app/profil/[userId].vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/app/src/pages/auth/login.vue")
  },
  {
    name: "auth-passwort-setzen-token",
    path: "/auth/passwort-setzen/:token()",
    component: () => import("/app/src/pages/auth/passwort-setzen/[token].vue")
  },
  {
    name: "auth-registrierung",
    path: "/auth/registrierung",
    component: () => import("/app/src/pages/auth/registrierung.vue")
  },
  {
    name: "auth-verifizierungsmail",
    path: "/auth/verifizierungsmail",
    component: () => import("/app/src/pages/auth/verifizierungsmail.vue")
  },
  {
    name: "datenschutz",
    path: "/datenschutz",
    component: () => import("/app/src/pages/datenschutz.vue")
  },
  {
    name: "faq",
    path: "/faq",
    component: () => import("/app/src/pages/faq.vue")
  },
  {
    name: "impressum",
    path: "/impressum",
    component: () => import("/app/src/pages/impressum.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/src/pages/index.vue")
  },
  {
    name: "kontakt",
    path: "/kontakt",
    component: () => import("/app/src/pages/kontakt.vue")
  },
  {
    name: "nutzungsbedingungen",
    path: "/nutzungsbedingungen",
    component: () => import("/app/src/pages/nutzungsbedingungen.vue")
  },
  {
    name: "suche",
    path: "/suche",
    component: () => import("/app/src/pages/suche.vue")
  },
  {
    name: "ueber-uns",
    path: "/ueber-uns",
    component: () => import("/app/src/pages/ueber-uns.vue")
  },
  {
    name: "veranstaltungen",
    path: "/veranstaltungen",
    component: () => import("/app/src/pages/veranstaltungen.vue")
  }
]